import { TrafficLightDetail } from '@cloudmatize/traffic-hub'

export function TrafficLightDetailPage() {
  return <TrafficLightDetail />
}
